import { CategoryTypes } from "../../utils/enums.utils";
import { SalesAttachmentsStatus, SalesQuarters, SalesStatus } from "./sales-response.interface";

export interface CreateSalesInterface {
  quarter: SalesQuarters;
  status: SalesStatus;
  category: CategoryTypes;
  po_number: string | null;
  invoice_number: string | null;
  dr_number: string | null;
  sales_remark: string | null;
  created_by_id: string | null;
  updated_by_id: string | null;
  monitoring_id: string;
}

export interface UpdateSalesInterface {
  id: string;
  quarter?: SalesQuarters;
  status?: SalesStatus;
  category?: CategoryTypes;
  po_number?: string | null;
  invoice_number?: string | null;
  dr_number?: string | null;
  sales_remark?: string | null;
  updated_by_id: string | null;
  monitoring_id?: string;
}

export interface CreateSaleAttachmentsInterface {
  sales_id: string;
  attachment_id: string;
  status: SalesAttachmentsStatus;
}

export interface UpdateSaleAttachmentsInterface {
  sales_id: string;
  attachment_id: string;
  status: SalesAttachmentsStatus;
}